import { Box, Divider, Typography } from '@material-ui/core'
import React from 'react'

function InternalComments() {
    return (
        <Box p={3}>
            <Typography variant="h1" style={{ fontWeight: "bold" }}>Internal comments</Typography>
            <Divider />
            <Box component="p">
                <Typography variant="h2">
                    All, Iste minus et. Non necessitatibus ut est est id amet. Officiis sequi dolorum assumenda ipsam magnam cum possimus. Laudantium nulla amet tempore excepturi id expedita dolorum quisquam deserunt. Odit vel sint dolor eos. Ea blanditiis animi. Quibusdam unde unde. Perspiciatis vel pariatur qui. Deleniti omnis est quae. Laboriosam numquam amet aliquid. Iste minus et. Non necessitatibus ut est est id amet. Officiis sequi dolorum assumenda ipsam magnam cum possimus. Laudantium nulla amet tempore excepturi id expedita dolorum quisquam deserunt. Odit vel sint dolor eos. Ea blanditiis animi. Quibusdam unde unde. Perspiciatis vel pariatur qui. Deleniti omnis est quae. Laboriosam numquam amet aliquid.Iste minus et. Non necessitatibus ut est est id amet. Officiis sequi dolorum.
                </Typography>
            </Box>
        </Box>
    )
}

export default InternalComments
